import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOnboarded: false, // Default value
};
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: initialState,
  reducers: {
    setOnboardingFlag: (state, action) => {
      state.isOnboarded = action.payload;
    },
    resetOnboardingFlag: (state) => {
      return { ...initialState };
    },
  },
});

export const { setOnboardingFlag,resetOnboardingFlag } = onboardingSlice.actions;

export default onboardingSlice.reducer;
